// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_3UZ32","clickButton":"PPirI","clickButtonWrapper":"NfEb0","viewButton":"_39ei5","divider":"_2ChwD"};